var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "logo-container" }, [
    _c("div", { class: ["logo", { "is-mobile": _setup.isMobileBreakpoint }] }, [
      _c("img", { attrs: { src: _setup.logo, alt: "Lefebvre logo" } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }